/**
 * アプリ全体のモーダル z-index 定義
 *
 * ■ 設計ルール
 *   L1: ページ直上のモーダル（FollowFormModal, BusinessCardDetailPage の各モーダル等）
 *       → mask={true}  ← ここだけマスクを持つ
 *   L2: L1 の中から開くサブモーダル（通知先設定, ファイルアップロード等）
 *       → mask={false}
 *   L3: L2 の中から開くサブモーダル（確認ダイアログ, 選択肢モーダル等）
 *       → mask={false}
 *   POPUP: Ant Design Select / DatePicker 等のポップアップ（デフォルト値、変更不要）
 *
 * ■ Android / iOS (Flutter WebView) 対応
 *   z-index は 1030 程度に収めることで WebView の重ね合わせ問題を回避する。
 *   極端に大きな値（100000 等）は使用しないこと。
 */
export const MODAL_Z = {
  /** ページ直上の第1層モーダル（マスクあり） */
  L1: 1000,
  /** L1 の中から開く第2層モーダル（mask={false}） */
  L2: 1010,
  /** L2 の中から開く第3層モーダル（mask={false}） */
  L3: 1020,
  /** Ant Design ポップアップ（Select / DatePicker 等）のデフォルト値 */
  POPUP: 1050,
} as const;
